import {
  CREATE_API_APPLICATION,
  GET_API_APPLICATION,
  GET_API_APPLICATIONS,
  REGENERATE_API_APPLICATION_TOKEN,
  UPDATE_API_APPLICATIONS,
} from '../types';
import { createAxiosAction } from '../utils';

export default {
  create: name => {
    return createAxiosAction({
      url: '/api/v1/apiApplications',
      method: 'POST',
      startAction: CREATE_API_APPLICATION,
      body: { name },
    });
  },
  getList: showDeleted => {
    return createAxiosAction({
      url: '/api/v1/apiApplications' + (showDeleted ? '?showDeleted=true' : ''),
      startAction: GET_API_APPLICATIONS,
    });
  },
  getSingle: id => {
    return createAxiosAction({
      url: '/api/v1/apiApplications/' + id,
      startAction: GET_API_APPLICATION,
    });
  },
  regenerateToken: id => {
    return createAxiosAction({
      url: `/api/v1/apiApplications/${id}/regenerateToken`,
      method: 'PATCH',
      startAction: REGENERATE_API_APPLICATION_TOKEN,
    });
  },
  update: (id, name, isDeleted) => {
    return createAxiosAction({
      url: '/api/v1/apiApplications',
      method: 'PUT',
      startAction: UPDATE_API_APPLICATIONS,
      body: { name, id, isDeleted },
    });
  },
};
